import { Component, OnInit } from '@angular/core';
import { ExaminerBookingSearchConfig } from '../../models/examiner-booking-search-config.model';
import { DwChildConfigBaseComponent, DwComponentSectionConfigPreference, DwMdSectionConfigBaseComponent } from '@devwareapps/devware-cap';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-examiner-booking-search-results-config',
  template: `
    <div *ngIf="section?.config">
      <div dwRow>
          <div dwCol="6">
              <label>Verify Existing Checkrides</label>
              <dw-yesno [(ngModel)]="section.config.verifyExistingCheckrides" (ngModelChange)="onSectionChange()"></dw-yesno>
          </div>
          <div dwCol="6">
              <label>Allow Multiple Bookings</label>
              <dw-yesno [(ngModel)]="section.config.allowMultipleBookings" (ngModelChange)="onSectionChange()"></dw-yesno>
          </div>
      </div>
        <div dwRow>
          <div dwCol="6">
              <label>Show Manual Booking button</label>
              <dw-yesno [(ngModel)]="section.config.showSchoolManualBookingButton" (ngModelChange)="onSectionChange()"></dw-yesno>
          </div>
        </div>
    </div>`
})
export class ExaminerBookingSearchResultsConfigComponent extends DwMdSectionConfigBaseComponent<DwComponentSectionConfigPreference<ExaminerBookingSearchConfig>> {

  setupComplete() {
    this.section.config = this.section?.config || {
      verifyExistingCheckrides: true,
      allowMultipleBookings: false
    };
  }
}


